// src/api/useFetchObject.js
import { useQuery } from "@tanstack/react-query";
import axios from "./axiosSetup";

const useFetchObject = (queryKey, endpoint, id, token) => {
  const fetchFunction = async () => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const response = await axios.get(
      `${endpoint}/${id}/`,
      {
        headers,
      },
    );
    return response.data;
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [queryKey],
    queryFn: fetchFunction,
  });

  return { data, isLoading, isError, error };
};

export default useFetchObject;
